// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"603":"97d9cd6c","4327":"4cd36faf","5083":"bf6c4823","5187":"97d9cd6c","6436":"97d9cd6c","9123":"97d9cd6c"}[chunkId] + ".chunk.css";
};